// Project
import request from "../request";

/**
 * @param {string} resource
 * @returns {Promise<string[]>}
 */
export const getMyPermissions = async (props) => {
	const { env } = props;

	const response = await request({
		url: `/${env}/me/permissions`,
	});

	return response.data;
};
